import gql from "graphql-tag";
import { DocumentNode, QueryOptions } from "@apollo/client";
import { GraphQlQueryBuilder } from "./graphQl-query.builder";
interface WidgetUserIDGraphQL {
  userId: string;
  language: string;
}
export class WidgetGraphQlBuilder {
  private userId: string;
  private language: string;
  private get _query(): DocumentNode {
    return gql`
      query findWidgetsByUser {
        miUsuario {
          dashboardsConnection {
            edges {
              uuid
              owner
              deleted
              node {
                uuid
                nombre
                descripcion
                deleted
                widgetsConnection {
                  edges {
                    uuid
                    posicion
                    x
                    y
                    width
                    height
                    node {
                      uuid
                      nombre
                      descripcion
                      widgetType {
                        uuid
                        descripcion
                        id_interno
                      }
                      parametros {
                        uuid
                        clave
                        valor
                        dispositivos {
                          uuid
                          descripcion
                          nombre
                        }
                        tipodatos {
                          uuid
                          nombre
                          nombre_es
                          nombre_en
                          unidad
                          codigo
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  }

  public withUserIdParam(userId: string): this {
    this.userId = userId;
    return this;
  }

  public withUserLanguage(language: string): this {
    this.language = language;
    return this;
  }

  public build(): QueryOptions {
    const queryParams: WidgetUserIDGraphQL = {
      userId: this.userId,
      language: this.language,
    };
    const graphQlBuilder: GraphQlQueryBuilder = new GraphQlQueryBuilder();
    return graphQlBuilder
      .withQuery(this._query)
      .withParams(queryParams)
      .build();
  }
}
